import React from 'react';
import { SectionId } from '../types';
import { FadeIn } from './ui/FadeIn';

// Use real wedding photos from gallery
const philosophyImages = {
  main: '/gallery/wedding-02/1F2A3862.webp',
  secondary: '/gallery/wedding-01/IMG_7003.webp',
  tertiary: '/gallery/wedding-03/1F2A0514.webp'
};

export const Philosophy: React.FC = () => {
  return (
    <section id={SectionId.PHILOSOPHY} className="py-24 md:py-40 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 items-center">
        
        <FadeIn>
            {/* Creative Photo Stack Layout */}
            <div className="relative h-[600px] md:h-[700px]">
                {/* Main Image - Large */}
                <div className="absolute top-0 left-0 w-[75%] h-[70%] overflow-hidden shadow-2xl z-10">
                    <img 
                        src={philosophyImages.main}
                        alt="Wedding moment" 
                        className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
                        loading="lazy"
                    />
                </div>
                
                {/* Secondary Image - Overlapping Right */}
                <div className="absolute top-[20%] right-0 w-[50%] h-[45%] overflow-hidden shadow-xl z-20 border-4 border-white">
                    <img 
                        src={philosophyImages.secondary}
                        alt="Celebration" 
                        className="w-full h-full object-cover"
                        loading="lazy"
                    />
                </div>
                
                {/* Tertiary Image - Bottom Left */}
                <div className="absolute bottom-0 left-[10%] w-[45%] h-[35%] overflow-hidden shadow-xl z-30 border-4 border-white">
                    <img 
                        src={philosophyImages.tertiary}
                        alt="Intimate moment" 
                        className="w-full h-full object-cover sepia hover:sepia-0 transition-all duration-700"
                        loading="lazy"
                    />
                </div>
                
                {/* Quote Overlay */}
                <div className="absolute bottom-12 right-0 bg-stone-900/95 backdrop-blur-sm p-6 md:p-8 max-w-[280px] z-40 shadow-xl">
                     <p className="font-serif italic text-lg md:text-xl text-stone-100 leading-relaxed">
                        "Every wedding is a story waiting to be unveiled."
                     </p>
                     <div className="w-8 h-[1px] bg-[#D4AF37] mt-4"></div>
                </div>
            </div>
        </FadeIn>

        <div className="flex flex-col justify-center">
            <FadeIn delay={200}>
                <p className="text-[10px] tracking-[0.3em] uppercase text-stone-400 mb-6">Our Philosophy</p>
                <h2 className="text-3xl md:text-5xl font-serif text-stone-900 mb-8 leading-tight">
                    More than documentation. <br/> We craft <span className="italic text-[#D4AF37]">legacy</span>.
                </h2>
                <div className="space-y-6 text-stone-600 font-light leading-relaxed text-base">
                    <p>
                        <strong className="font-medium text-stone-800">Anavaran</strong> means "Unveiling". Our approach is rooted in the belief that the most beautiful moments are often the quietest ones — the stolen glances, the tearful smiles, the silent prayers.
                    </p>
                    <p>
                        We operate globally, bringing a refined, cinematic eye to Indian weddings across the world. From the palaces of Rajasthan to the beaches of Bali, we blend into the background to capture the raw, unscripted essence of your celebration.
                    </p>
                </div>
                
                {/* Stats with Golden Accents */}
                <div className="mt-12 grid grid-cols-3 gap-8 border-t border-stone-200 pt-8">
                    <div className="group">
                        <span className="block text-3xl font-serif text-stone-900 group-hover:text-[#D4AF37] transition-colors duration-300">150<span className="text-[#D4AF37]">+</span></span>
                        <span className="text-[9px] uppercase tracking-[0.2em] text-stone-400 mt-1 block">Weddings</span>
                    </div>
                    <div className="group">
                        <span className="block text-3xl font-serif text-stone-900 group-hover:text-[#D4AF37] transition-colors duration-300">12</span>
                        <span className="text-[9px] uppercase tracking-[0.2em] text-stone-400 mt-1 block">Countries</span>
                    </div>
                    <div className="group">
                        <span className="block text-3xl font-serif text-[#D4AF37]">∞</span>
                        <span className="text-[9px] uppercase tracking-[0.2em] text-stone-400 mt-1 block">Memories</span>
                    </div>
                </div>
            </FadeIn>
        </div>

      </div>
    </section>
  );
};